import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Member, YoungSun, Order, Logout } from "@/js/services/baseService";
import { computed, reactive } from "vue";
import creteStoreUtil from '@/store/store-util';
var defaultState = {
  token: '',
  isLogined: false,
  // 目前總點數
  total_point: 0,
  // 點數比例
  point_proportion: 0,
  // 紀錄列表
  log_list: [],
  // 會員ID
  id: '',
  member_name: '',
  member_name_encrypt: '',
  gender: '',
  birthday: '',
  // 有未讀coupon
  is_member_coupon_unread: '',
  // 帳號
  mobile: '',
  // 手機
  phone: '',
  email: '',
  city_name: '',
  area_name: '',
  address: '',
  account: '',
  account_encrypt: '',
  is_edm: '',
  // 會員卡號
  member_card: '',
  member_no: '',
  vehicle: '',
  // 預設門市 - 名稱
  store_name: '',
  // 預設門市 - 地址
  store_addr: '',
  // 預設門市 - id
  store_id: '',
  // 預設行動超市 - id
  action_store_id: '',
  // 預設行動超市 - 名稱
  action_store_name: '',
  // 預設行動超市 - 地址
  action_store_addr: '',
  // 紀錄會員瀏覽時的行動超市- id
  viewed_action_store_id: '',
  // 紀錄會員瀏覽時的行動超市- 名稱
  viewed_action_store_name: '',
  // 紀錄會員瀏覽時的行動超市- 地址
  viewed_action_store_addr: '',
  // 待領取訂單數量
  unreceive_orders_num: {
    // 全部未取數量
    num: '',
    // 線上預購未取
    orders_num: '',
    // 行動超市未取
    action_orders_num: ''
  },
  // 會員被設為黑名單
  is_blacklist: 0
};

var _creteStoreUtil = creteStoreUtil({
  defaultState: defaultState
}),
    init = _creteStoreUtil.init,
    getData = _creteStoreUtil.getData,
    setData = _creteStoreUtil.setData,
    resetData = _creteStoreUtil.resetData,
    initState = _creteStoreUtil.initState;

export default {
  namespaced: true,
  state: function state() {
    return {};
  },
  getters: {
    getData: getData
  },
  actions: {
    init: init,
    updateMemberData: function updateMemberData(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var commit, res, _ajax200Res, onSuccess, onFail;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.next = 3;
                return Member.member_data();

              case 3:
                res = _context.sent;
                _ajax200Res = ajax200Res(res), onSuccess = _ajax200Res.onSuccess, onFail = _ajax200Res.onFail;
                onSuccess(function (_ref2) {
                  var res = _ref2.res,
                      data = _ref2.data,
                      msg = _ref2.msg,
                      defaultAlert = _ref2.defaultAlert;

                  // console.log('Member.member_data onSuccess',data)
                  if (data) {
                    var toSet = {};

                    for (var key in defaultState) {
                      if (data[key] !== undefined) {
                        toSet[key] = data[key];
                      }
                    }

                    commit('setData', toSet);
                  }
                });
                onFail(function (_ref3) {
                  var res = _ref3.res,
                      data = _ref3.data,
                      msg = _ref3.msg,
                      defaultAlert = _ref3.defaultAlert;
                  console.log('Member.member_data fail', res.data);

                  if (msg) {
                    defaultAlert();

                    if (res.data.res_code == -2) {
                      // 登出
                      Logout();
                    }
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 更新 - 會員點數記錄
    updateMemberPointRecord: function updateMemberPointRecord(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var commit, state, ps1, ps2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref4.commit, state = _ref4.state;

                if (state.member_no) {
                  _context2.next = 5;
                  break;
                }

                alertCustom("登入時效已過期", "請重新登入會員", function () {});
                Logout();
                return _context2.abrupt("return");

              case 5:
                _context2.next = 7;
                return YoungSun.member_point_record({
                  member_no: state.member_no
                }).then(function (res) {
                  var _ajax200Res2 = ajax200Res(res),
                      onSuccess = _ajax200Res2.onSuccess,
                      onFail = _ajax200Res2.onFail;

                  onSuccess(function (_ref5) {
                    var res = _ref5.res,
                        data = _ref5.data,
                        msg = _ref5.msg,
                        defaultAlert = _ref5.defaultAlert;

                    if (data) {
                      commit('setData', {
                        total_point: data.total_point,
                        log_list: data.log_list
                      });
                    }
                  });
                  onFail(function (_ref6) {
                    var res = _ref6.res,
                        data = _ref6.data,
                        msg = _ref6.msg,
                        defaultAlert = _ref6.defaultAlert;

                    if (msg) {
                      defaultAlert();
                    } else {
                      console.log('YoungSun.member_point_record');
                    }
                  });
                });

              case 7:
                ps1 = _context2.sent;
                console.log('updateMemberPointRecord===============', state.member_no);
                ps2 = YoungSun.point_proportion().then(function (res) {
                  var _ajax200Res3 = ajax200Res(res),
                      onSuccess = _ajax200Res3.onSuccess,
                      onFail = _ajax200Res3.onFail;

                  onSuccess(function (_ref7) {
                    var res = _ref7.res,
                        data = _ref7.data,
                        msg = _ref7.msg,
                        defaultAlert = _ref7.defaultAlert;

                    if (data) {
                      commit('setData', {
                        point_proportion: data.point_proportion
                      });
                    }
                  });
                  onFail(function (_ref8) {
                    var res = _ref8.res,
                        data = _ref8.data,
                        msg = _ref8.msg,
                        defaultAlert = _ref8.defaultAlert;

                    if (msg) {
                      defaultAlert();
                    } else {
                      console.log('YoungSun.point_proportion fail');
                    }
                  });
                });
                return _context2.abrupt("return", Promise.allSettled([ps1, ps2]));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 更新 - 待領取訂單數量
    updateUnreceiveOrdersNum: function updateUnreceiveOrdersNum(_ref9) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var commit, res, _ajax200Res4, onSuccess, onFail;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref9.commit;
                _context3.next = 3;
                return Order.get_unreceive_orders_num();

              case 3:
                res = _context3.sent;
                _ajax200Res4 = ajax200Res(res), onSuccess = _ajax200Res4.onSuccess, onFail = _ajax200Res4.onFail;
                onSuccess(function (_ref10) {
                  var res = _ref10.res,
                      data = _ref10.data,
                      msg = _ref10.msg,
                      defaultAlert = _ref10.defaultAlert;

                  if (data) {
                    commit('setData', {
                      unreceive_orders_num: {
                        // 全部未取數量
                        num: data.num,
                        // 線上預購未取
                        orders_num: data.orders_num,
                        // 行動超市未取
                        action_orders_num: data.action_orders_num
                      }
                    });
                  }
                });
                onFail(function (_ref11) {
                  var res = _ref11.res,
                      data = _ref11.data,
                      msg = _ref11.msg,
                      defaultAlert = _ref11.defaultAlert;

                  if (msg) {
                    defaultAlert();

                    if (res.data.res_code == -2) {
                      // 登出
                      Logout();
                    }
                  }
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    updateMemberCouponUnread: function updateMemberCouponUnread(_ref12) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var commit, res, _ajax200Res5, onSuccess, onFail;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit = _ref12.commit;
                _context4.next = 3;
                return Member.is_member_coupon_unread();

              case 3:
                res = _context4.sent;
                _ajax200Res5 = ajax200Res(res), onSuccess = _ajax200Res5.onSuccess, onFail = _ajax200Res5.onFail;
                onSuccess(function (_ref13) {
                  var res = _ref13.res,
                      data = _ref13.data,
                      msg = _ref13.msg,
                      defaultAlert = _ref13.defaultAlert;

                  if (data) {
                    commit('setData', {
                      is_member_coupon_unread: data.unread
                    });
                  }
                });
                onFail(function (_ref14) {
                  var res = _ref14.res,
                      data = _ref14.data,
                      msg = _ref14.msg,
                      defaultAlert = _ref14.defaultAlert;

                  if (msg) {
                    defaultAlert();

                    if (res.data.res_code == -2) {
                      // 登出
                      Logout();
                    }
                  }
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  mutations: {
    initState: initState,
    setData: setData,
    resetData: resetData,
    // 設定瀏覽用的行動超市
    setViewUseActionStore: function setViewUseActionStore(state, data) {
      if (data) {
        state.viewed_action_store_id = data.id;
        state.viewed_action_store_name = data.name;
        state.viewed_action_store_addr = data.address;
      }
    }
  }
};